<template>
<div class="chapter">
<div class="inner_page">
<a id="page_iii"></a>
<h1 class="title">B<span class="small-caps">ATTLE OF</span> L<span class="small-caps">EYTE</span> G<span class="small-caps">ULF</span></h1>
<p class="titlea">T<span class="small-caps">HE</span> L<span class="small-caps">ARGEST</span> S<span class="small-caps">EA</span> B<span class="small-caps">ATTLE OF THE</span> S<span class="small-caps">ECOND</span> W<span class="small-caps">ORLD</span> W<span class="small-caps">AR</span></p>
<p class="author">John Grehan and Alexander Nicoll</p>
<div class="image_container1">
<img alt="images" src="images/f0003-01.jpg"/>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 02_Title.vue?e6dd90d8